import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('mediaGalleryPrivata');
export const actions = helper.createActions('mediaGalleryPrivata', actionTypes);